import type { IGatsbyImageData } from 'gatsby-plugin-image';

import type { Lucid } from '../../types/types';

export type IntegrationItem = {
  id: string;
  title: string;
  image: IGatsbyImageData;
};

const withMarketplaceIntegrations = (integrations: Lucid.Query.Hooks.UseMarketplaceIntegrations) =>
  integrations.allMarketplaceIntegration?.nodes?.reduce((prev, curr) => {
    const image = curr.icon48?.childImageSharp?.gatsbyImageData;

    return [...prev, { title: curr.title, image, id: curr.packageId }] as IntegrationItem[];
  }, [] as IntegrationItem[]);

export default withMarketplaceIntegrations;
